import React, { ReactNode } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { SingleArrowDown } from '@r1-frontend/ui-react/components/svg/arrows';

import { TThemesColors } from './themes';

import * as ST from './styled';

interface IPropsHeader {
    onOpen: () => void,
    isOpen: boolean,
    colors: TThemesColors,
    children: ReactNode,
    itemProp?: string,
    itemScope?: boolean,
    itemType?: string,
    showButton?: boolean,
}

export const Header = ({ onOpen, isOpen, colors, children, showButton = true, ...rest }: IPropsHeader): JSX.Element => {
    const {
        buttonType = 'white',
        buttonTypeIsOpen = 'secondary',
        colorArrow,
        colorArrowIsOpen,
        backgroundIcon,
        backgroundIconIsOpen,
        borderIcon,
        borderIconIsOpen,
    } = colors;

    return (
        <ST.TitleContainer onClick={onOpen} data-test='title' {...rest}>
            {children}
            {showButton &&
                <Button
                    rounded={true}
                    size={'small'}
                    bType={isOpen ? buttonTypeIsOpen : buttonType}
                    Icon={
                        <ST.Icon
                            isOpen={isOpen}
                            arrowColor={isOpen ? colorArrowIsOpen : colorArrow}
                            iconBackground={isOpen ? backgroundIconIsOpen : backgroundIcon}
                            iconBorder={isOpen ? borderIconIsOpen : borderIcon}
                        >
                            <SingleArrowDown/>
                        </ST.Icon>
                    }
                />
            }
        </ST.TitleContainer>
    );
};

interface IPropsTitle {
    children: JSX.Element | string,
    itemProp?: string,
}

export const Title = ({ children, ...rest }: IPropsTitle): JSX.Element =>
    <ST.Title as={'h3'} {...rest}>{children}</ST.Title>;
